import { AutociteMetadataInput } from '../globalTypesOneGraph'
import {
  AutociteCslData_autociteCslData,
  AutociteCslData_autociteCslData_authors,
} from '../oneGraphQueries/__generated__/AutociteCslData'
import { formattedAutociteSource } from './searchSources'

const mapAutociteContributors = (
  contributors: AutociteCslData_autociteCslData_authors[],
  contributorFunction: string
) => {
  if (!Array.isArray(contributors)) return []
  return contributors.map((contrib) => ({
    [`${contributorFunction}GivenName`]: contrib.givenName,
    [`${contributorFunction}LastName`]: contrib.lastName,
  }))
}

export const cslV1ToRioAutociteResponse = (
  csl: AutociteCslData_autociteCslData
): AutociteMetadataInput => {
  const resp = {
    accessedPublicationDay: csl.accessedPublication?.day,
    accessedPublicationMonth: csl.accessedPublication?.month,
    accessedPublicationYear: csl.accessedPublication?.year,
    authors: mapAutociteContributors(csl.authors, 'author'),
    containerTitle: csl.containerTitle,
    contentSource: formattedAutociteSource(csl.contentType),
    contentTitle: csl.contentTitle,
    editors: mapAutociteContributors(csl.editors, 'editor'),
    issuedPublicationDay: csl.issuedPublication?.day,
    issuedPublicationMonth: csl.issuedPublication?.month,
    issuedPublicationYear: csl.issuedPublication?.year,
    publisherName: csl.publisherName,
    translators: mapAutociteContributors(csl.translators, 'translator'),
    url: csl.url,
  }
  return resp
}
